import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_wrkrs_paid_directly_by_the_fac_or_through_3rd_party_agents'

export const dataPointDefinition = {
  retracedId: 'are_wrkrs_paid_directly_by_the_fac_or_through_3rd_party_agents',
  name: 'Are workers paid directly by the facility or through 3rd party agents?',
  description:
    'The intent of this question is to understand WHO actually pays workers. \r\r\n\r\r\nIs it the facility? A 3rd Party Agent (i.e. labor agents/recruiting agents/labor brokers). Another entity? \r\r\n\r\r\nFor example, if some workers are directly paid by the facility and some workers are paid through a 3rd party agent, the response selections of "Both" should be selected.',
  meta: {},
  fieldTypeId: 'SELECT_WITH_FOLLOW_UP',
  type: 'RELATIONAL',
  options: [
    {
      name: 'By the Facility',
      key: 'BY_THE_FAC',
      slcpIndex: 1,
      slcpOptionName: 'paid-by',
    },
    {
      name: 'By 3rd Party Agents',
      key: 'BY_3RD_PARTY_AGENTS',
      slcpIndex: 2,
      slcpOptionName: 'paid-by',
    },
    {
      name: 'Both',
      key: 'BOTH',
      slcpIndex: 3,
      slcpOptionName: 'paid-by',
    },
    {
      name: 'Other',
      key: 'OTHER',
      slcpIndex: 4,
      slcpOptionName: 'paid-by',
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'wb-15--2-4f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'object',
        properties: {
          value: {
            type: 'string',
            enum: ['BY_THE_FAC', 'BY_3RD_PARTY_AGENTS', 'BOTH', 'OTHER'],
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['value', 'followUp'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-15--2',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 8670,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
